import { Routes } from '@angular/router';

import { TERMS_LANGUAGES, TermsLanguage } from '@core/models/terms/terms-version.model';

import { TermsPageComponent } from './terms-page.component';

const isTermsLanguage = (value: string | null | undefined): value is TermsLanguage =>
  TERMS_LANGUAGES.includes(value as TermsLanguage);

/** Same order the static chooser used: the app's saved language, then the browser's, then French. */
export function pickTermsLanguage(
  saved: string | null,
  browser: readonly string[]
): TermsLanguage {
  if (isTermsLanguage(saved)) return saved;
  return browser.map((tag) => tag.split('-')[0]).find(isTermsLanguage) ?? 'fr';
}

const chooseLanguage = (): string => {
  let saved: string | null;
  try {
    saved = localStorage.getItem('gfe-lang');
  } catch {
    saved = null;
  }
  return `/terms-and-conditions/${pickTermsLanguage(saved, navigator.languages ?? [])}`;
};

/** No auth guard: the terms must be readable before logging in. */
export const termsPageRoutes: Routes = [
  {
    path: 'terms-and-conditions/:lang',
    canMatch: [(_route, segments) => isTermsLanguage(segments[1]?.path)],
    component: TermsPageComponent
  },
  { path: 'terms-and-conditions/:lang', redirectTo: chooseLanguage },
  { path: 'terms-and-conditions', pathMatch: 'full', redirectTo: chooseLanguage }
];
